<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <div
          v-if="
        data.item.observacionesDiagnostico != null ||
          data.item.observacionesDiagnostico != ''
      "
      >
        <b-button size="sm" @click="showModal(data.item)" :disabled="data.item.observacionesDiagnostico == null"
                  variant="outline-info" >Observaciones diagnóstico</b-button
        >


      </div>

      <div v-else>
        <p>No hay observaciones</p>
      </div>
    </div>
    <div v-if="data.item.rechazado && data.item.motivoRechazo !== null && data.item.motivoRechazo !== ''">
      <b-button variant="outline-info" class="mt-2"
                @click="showModalRechazo(data.item)">
        Observaciones de Rechazo
      </b-button>
    </div>

  </div>
</template>

<script>
export default {
  name: "BandejaObservacionesDiagnostico",
  props: {
    data: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    showModal(idSolicitudDiagnostico) {
      this.$emit("_funcionExtra2", idSolicitudDiagnostico);
    },
    showModalRechazo(idSolicitudDiagnostico) {
      this.$emit("_funcionExtra3", idSolicitudDiagnostico);
    },
  },
};
</script>
